import { COMMON_MODALS } from "./common"
import { MATCH_MODALS } from "./match"
import { MATCHMAKING_MODALS } from "./matchmaking"
import { SHOP_MODALS } from "./shop"
import { WALLET_MODALS } from "./wallet"

export const MODAL_CONFIG = {
  ...COMMON_MODALS,
  ...MATCH_MODALS,
  ...MATCHMAKING_MODALS,
  ...SHOP_MODALS,
  ...WALLET_MODALS
} as const

export const ALL_MODALS = Object.keys(
  MODAL_CONFIG
) as (keyof typeof MODAL_CONFIG)[]
export type ModalType = keyof typeof MODAL_CONFIG

export type GetModalComponent<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { component: infer C } ? C : never

export type GetModalParams<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { params: infer P } ? P : undefined

export type OpenModalArgs<T extends ModalType> =
  GetModalParams<T> extends undefined
    ? []
    : Partial<GetModalParams<T>> extends GetModalParams<T>
      ? [params?: GetModalParams<T>]
      : [params: GetModalParams<T>]

export type GetModalInRouter<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { inRouter: infer R } ? R : true

export type HasComponent<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { component: any } ? true : false

export const MODAL_PARAMS_MAP = Object.entries(MODAL_CONFIG).reduce(
  (acc, [name, config]) => {
    if ("params" in config) {
      acc[name] = (config as any).params
    }
    return acc
  },
  {} as Record<string, any>
)
